import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:code',
    name: 'home',
    component:()=>import("../views/Home.vue")
  },
  {
    path: '/pcHome',
    name: 'pcHome',
    component:()=>import("../views/pcHome/pcHome.vue")
  },
  {
    path:"/mobileHome",
    name:"mobileHome",
    component:()=>import("../views/mobileHome/mobileHome.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
